import { useState } from 'react';
import { notification } from 'antd';
import { RcFile } from 'antd/lib/upload';
export type IfileUploadHook = (allowedType: string[]) => IfileUploadHookReturn;

export type IfileUploadHookReturn = {
  fileList: RcFile[];
  beforeUpload: (file: RcFile) => boolean;
  onRemove: () => void;
};

export const useFileUploadHook: IfileUploadHook = allowedType => {
  const [fileList, setImageFile] = useState<Array<RcFile>>([]);

  const beforeUpload = (file: RcFile): boolean => {
    if (!allowedType.includes(file.type)) {
      notification.error({
        message: `Unsupported File`,
        description: `${allowedType.join(',')} types are supported`
      });
    } else {
      setImageFile([file]);
    }
    return false;
  };

  const onRemove = (): void => {
    setImageFile([]);
  };

  return {
    fileList,
    beforeUpload,
    onRemove
  };
};
